import ajaxDispatcher from './functions/ajaxDispatcher';

export default function autocomplete() {
    const input = document.getElementById("ke_search_sword");
    const autocompleteBox = document.createElement("div");
    autocompleteBox.classList.add("autocomplete-box");
    input.parentNode.appendChild(autocompleteBox);

    input.addEventListener("input", function () {
        const value = this.value;
        if (value.length < 2) {
            autocompleteBox.innerHTML = "";
            return;
        }
        ajaxDispatcher(
            'Template',
            'Ajax',
            'Autocomplete',
            'search',
            false,
            { term: value },
            function (json) {
                autocompleteBox.innerHTML = "";

                json.forEach(item => {
                    if (item.isButton) {
                        const button = document.createElement("a");
                        button.href = item.url;
                        button.className = "autocomplete-button";
                        button.textContent = item.label;
                        autocompleteBox.appendChild(button);
                    } else {
                        const entry = document.createElement("div");
                        entry.className = "autocomplete-item";
                        entry.innerHTML = `<a href="${item.url}"><strong>${item.title}</strong><br><div itemprop="teaser">${item.teaser}</div></a>`;
                        autocompleteBox.appendChild(entry);
                    }
                });
            }
        );

    });
}
